import { LittleModalCreateEdit } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { ShippingCompanyModelType } from '@teinor/erp/types/company/config/shipping/shippingCompany'
import { SupplierPayload } from '../../../../../../../utils/reducers/products/suppliers'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import { ConnectedProps, connect } from 'react-redux'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import { dictionaryComplexFromJsonArr, TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import { useCallback, useEffect, useState } from 'react'
import { twinFetchPostJSON } from '../../../../../../../utils/globals/data'

type ShippingCompanyModelTypeAndServiceMain = ShippingCompanyModelType  & {
    ShippingServiceId: number
}


interface ModalCEConfigShippingCompanyProps extends ModalEditComponentProps { }

const ModalCEConfigShippingCompany: React.FC<ModalCEConfigShippingCompanyProps & ReduxModalCEConfigShippingCompanyConnector> = ({ userPermissions, allRowData, suppliers,  ...rest }) => {
    const { t } = useTwinTranslation()
    const { creditorId, handleChangeCreditorId, dictCreditors, dictCreditorServices } = useModalCEConfigShippingCompanyLogic({ suppliers, creditorIdRow: allRowData?.SupplierId })
    
    const fields: FormRender<ShippingCompanyModelTypeAndServiceMain> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'SupplierId',
                    label: t('creditor', 'Acreedor'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: dictCreditors,
                    required: true,
                    value: creditorId,
                    onChange: handleChangeCreditorId,
                },
                {
                    name: 'SupplierServiceId',
                    label: t('service', 'Servicio'),
                    component: 'CustomSelect',
                    sortItems: true,
                    items: dictCreditorServices || {},
                    required: true,
                    value: allRowData?.SupplierServiceId
                },
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                },
                {
                    name: 'factor',
                    label: t('factorVolKgMeters', 'Factor Volumen kg/m3'), 
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                }
            ]
        },
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit fields={parsedFields} url={'/api/app/config/shipping/shippingCompany/updateShippingCompany'} translations={{ title: t('editShippingCompany', 'Editar transportista'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }

    return (<LittleModalCreateEdit fields={fields} url={'/api/app/config/shipping/shippingCompany/createShippingCompany'} translations={{
        title: t('createNewShippingCompany', 'Crear nuevo transportista'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

interface ModalCEConfigShippingCompanyLogicProps {
    suppliers: SupplierPayload
    creditorIdRow?: number
}

const useModalCEConfigShippingCompanyLogic = ({ suppliers, creditorIdRow }: ModalCEConfigShippingCompanyLogicProps) => {
    const [creditorId, setCreditorId] = useState<undefined | number>(creditorIdRow)
    const [dictCreditorServices, setDictCreditorServices] = useState<TwinDictionary | null>(null)
    const dictCreditors = suppliers?.creditors || {}

    const handleChangeCreditorId = useCallback((id: number) => {
        setCreditorId(id)
    }, [setCreditorId])
    
    const getCreditorServices = useCallback(async () => {
        if (creditorId) {
            const result = await twinFetchPostJSON('/api/app/supplier/service/getAllSupplierServices', {
                where: {
                    SupplierId: creditorId
                }
            })
            if (result) {
                setDictCreditorServices(dictionaryComplexFromJsonArr(result))
            }
        }
    }, [creditorId])

    useEffect(() => {
        getCreditorServices()
    }, [getCreditorServices])
    
    return { creditorId, handleChangeCreditorId, dictCreditors, dictCreditorServices }
}


const modalCEConfigShippingCompanyDispatch = {
    setSuppliers: (payload: SupplierPayload) => ({ type: 'CHANGE_SUPPLIER', payload }),
}
const mapModalCEConfigShippingCompanyConnector = (state: AllReduxPayloads) => ({ suppliers: state.suppliers})
const modalCEConfigShippingCompanyConnector = connect(mapModalCEConfigShippingCompanyConnector, modalCEConfigShippingCompanyDispatch)
type ReduxModalCEConfigShippingCompanyConnector = ConnectedProps<typeof modalCEConfigShippingCompanyConnector>

const modalCEConfigShippingCompanyConnectLoading = withLoading(ModalCEConfigShippingCompany, [{ fetchUrl: '/api/app/supplier/getAllSuppliersComplete', propName: 'suppliers', setFunctionName: 'setSuppliers' }])

const ModalCEConfigShippingCompanyConnect = modalCEConfigShippingCompanyConnector(modalCEConfigShippingCompanyConnectLoading)


export default ModalCEConfigShippingCompanyConnect